(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["assem-product-design"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('assem-product-favorite'))customElements.define('assem-product-favorite',class extends HTMLElement{
 connectedCallback(){this.abort?.abort();this.abort=new AbortController();const button=this.querySelector('button');if(!button)return;const key='assem-kids-favorites-v1';const sync=()=>{let ids=[];try{ids=JSON.parse(localStorage.getItem(key)||'[]');if(!Array.isArray(ids))ids=[];}catch{}const saved=ids.includes(this.dataset.productId);button.setAttribute('aria-pressed',String(saved));button.textContent=saved?'♥':'♡';return ids;};sync();button.addEventListener('click',()=>{const ids=new Set(sync());ids.has(this.dataset.productId)?ids.delete(this.dataset.productId):ids.add(this.dataset.productId);try{localStorage.setItem(key,JSON.stringify([...ids]));}catch{}sync();document.dispatchEvent(new CustomEvent('assem:favorites-changed'));},{signal:this.abort.signal});document.addEventListener('assem:favorites-changed',sync,{signal:this.abort.signal});}
 disconnectedCallback(){this.abort?.abort();}
});
  } catch(e) { console.error(e); }
})();

})();
